import { faImage, faSignature, faStamp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@modusign/design-system';
import PropTypes from 'prop-types';
import PropsType from 'props-type';

import SignatureIcon from '@app/components/SignatureIcon';
import { participantOrder1 } from '@app/theme/colors';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  type: PropTypes.oneOf([
    'CIRCLE',
    'SIGN',
    'SIGN_NO_CIRCLE',
    'STAMP',
    'STAMP_UPLOAD_ONLY',
  ] as const),
};

const defaultProps = {
  color: participantOrder1,
  size: 20,
  type: 'CIRCLE',
};

type SignatureFieldMarkerIconProps = PropsType<typeof propTypes, typeof defaultProps>;

function SignatureFieldMarkerIcon({ color, size, type }: SignatureFieldMarkerIconProps) {
  switch (type) {
    case 'SIGN':
      return (
        <Box color={color} display="inline" height={`${size}px`} width={`${size}px`}>
          <FontAwesomeIcon fontSize={`${size}px`} icon={faSignature} />
        </Box>
      );
    // TODO (@Juyeong-Byeon): Check below unnecessary
    case 'SIGN_NO_CIRCLE':
      return (
        <Box
          as="svg"
          fill="none"
          sx={{ color, height: size, width: size }}
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.25172 16.7789C6.98876 13.6496 9.95354 10.2481 10.1461 6.57422C10.4349 1.06346 6.40366 1.55717 5.62441 6.8729C4.84515 12.1886 7.35726 15.2569 9.50343 15.3693C11.6496 15.4818 13.868 14.2166 13.6072 10.9795C13.3464 7.7424 11.5163 9.08932 11.42 10.9262C11.3237 12.7632 11.2204 15.4593 18.0881 15.8192"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </Box>
      );
    case 'STAMP_UPLOAD_ONLY':
      return (
        <Box color={color} display="inline" height={`${size}px`} width={`${size}px`}>
          <FontAwesomeIcon fontSize={size} icon={faImage} />
        </Box>
      );
    case 'STAMP':
      return (
        <Box color={color} display="inline" height={`${size}px`} width={`${size}px`}>
          <FontAwesomeIcon fontSize={size} icon={faStamp} />
        </Box>
      );
    default:
      return <SignatureIcon color={color} size={size} />;
  }
}

SignatureFieldMarkerIcon.propTypes = propTypes;
SignatureFieldMarkerIcon.defaultProps = defaultProps;

export default SignatureFieldMarkerIcon;
